export default function cleanUpAnimation(element){
  element.style.animationName = 'none'
}